import { DateTime } from "luxon";

export function calculateDurationFromDates(
  date1: string,
  date2: string
): string {
  const parsedDuration = DateTime.fromISO(date2).diff(DateTime.fromISO(date1));
  return parsedDuration.toFormat("h'h' m'm'");
}
